// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export const AVRO_SYNC_MARKER_SIZE: number = 16;
export const AVRO_INIT_BYTES: Uint8Array = new Uint8Array([79, 98, 106, 1]);
export const AVRO_CODEC_KEY: string = "avro.codec";
export const AVRO_SCHEMA_KEY: string = "avro.schema";
